<table class="table">
  <ng-content></ng-content>
</table>
